const RedBlack = [
    {id: "0", value: "紅K線"},    
    {id: "1", value: "黑K線"},        
  ];  
  
  export default RedBlack  